import userReducer from "./reducers/user";
import homeTabReducer from "./reducers/homeTab";
import { combineReducers } from "redux";
import notificationReducer from "./reducers/notification";
import widgetReducer from "./reducers/widget";

import imageReducer from "./reducers/image";
import permissionReducer from "./reducers/permission";
import giverPermissionReducer from "./reducers/givenPermission";
import userstatusReducer from "./reducers/userstatus";
import registerDropdownValues from './reducers/registrationDropdown';
import hoverUserReducer from "./reducers/hoverUser";
import sideBarLinksReducer from "./reducers/sideBarLinks";
import brandVisualReducer from "./reducers/brandVisuals";
import assessmentReducer from "./reducers/assessment";
import examCenterReducer from "./reducers/examCenter";
import examNameReducer from "./reducers/examName";
import examPeriodReducer from "./reducers/examPeriod";
import hoverTopicReducer from "./reducers/hoverTopic";
import hoverKeywordReducer from "./reducers/hoverKeyword";
import brand_override_reducer from "./reducers/brand_override";
import course_type_reducer from "./reducers/courseType";
import file_system from "./reducers/file_system";

const rootReducer = combineReducers({
  user: userReducer,
  tabs: homeTabReducer,
  notification: notificationReducer,
  widget: widgetReducer,
  image: imageReducer,
  permission: permissionReducer,
  givenPermission: giverPermissionReducer,
  userstatus: userstatusReducer,
  registerDropdownValues: registerDropdownValues,
  hoverUser: hoverUserReducer,
  hoverTopic: hoverTopicReducer,
  hoverKeyword: hoverKeywordReducer,
  sideBarLinks: sideBarLinksReducer,
  brandVisuals:brandVisualReducer,
  assessment:assessmentReducer,
  examCenterReducer:examCenterReducer,
  examNameReducer:examNameReducer,
  examPeriodReducer:examPeriodReducer,
  brand_override_reducer:brand_override_reducer,
  course_type_reducer : course_type_reducer,
  file_system_reducer : file_system
});
export default rootReducer;
